import { FieldType, FormControlModel, PROMPTS, WidthClass } from '@thehubz/client/core';
import { Asset } from '@thehubz/client/data-access-api';

export const PURSUE = [
  { _id: 'fsb', name: 'FSB' },
  { _id: 'group', name: 'KONZERN' },
  { _id: 'sav', name: 'SAV' },
  { _id: 'sparkasse', name: 'Sparkasse - AOK - SVLFG' },
  { _id: 'ukv', name: 'UKV' },
  { _id: 'urv', name: 'URV' },
  { _id: 'vkb', name: 'VKB' },
];

export const MEDIA_USAGE = [
  { _id: 'allMedia', name: 'Alle Medien', tooltip: 'Das Asset darf in allen Medien eingesetzt werden.' },
  {
    _id: 'allMediaExcept',
    name: 'Alle Medien - außer',
    tooltip: 'Das Asset darf nicht für die aufgeführten Medien genutzt werden. Bitte im Feld „Mediennutzung - Ausnahme(n)“ angeben.',
    tooltipUser: 'Das Asset darf nicht für die aufgeführten Medien genutzt werden (z.B. „Mediennutzung - Ausnahme(n): online“).',
  },
];

export const EXCLUSIVITY = [
  {
    _id: 'exclusive',
    name: 'Exklusiv',
    tooltip: 'Nur unsere Konzern-Unternehmen dürfen das Asset benutzen. I.d.R. sind das von uns geshootete/ erstellte Assets.',
  },
  {
    _id: 'notExclusive',
    name: 'Nicht exklusiv',
    tooltip:
      'Ein Asset, das bei einer Bildagentur (z.B. Getty Images) gekauft wurde, kann auch von anderen Firmen und Wettbewerbern gekauft und benutzt werden. Bitte im Feld „Exklusivität - Ausnahme(n)“ angeben.',
    tooltipUser:
      'Ein Asset, das bei einer Bildagentur (z.B. Getty Images) gekauft wurde, kann auch von anderen Firmen und Wettbewerbern gekauft und benutzt werden.',
  },
];

export const IMAGE_ART = [
  { _id: 'stockMaterial', name: 'Stockmaterial', tooltip: 'zugekauftes Asset aus einer Bilddatenbank' },
  { _id: 'photographedAsset', name: 'Geshootetes Asset', tooltip: 'z.B. Konzernshooting oder im Rahmen von Kampagnen' },
  { _id: 'aiGeneratedAsset', name: 'KI generiertes Asset', tooltip: 'KI-Label gilt für alle hier aufgeführten Bildarten' },
  { _id: 'leitmotifWithoutUmbrella', name: 'Leitmotiv ohne Schirm', tooltip: 'Key Visual ohne Corporate-Elemente' },
  { _id: 'leitmotifWithUmbrella', name: 'Leitmotiv mit Schirm', tooltip: 'dadurch wird das Asset exklusiv für die jeweilige Marke' },
  { _id: 'stageDesign', name: 'Bühnenbild', tooltip: 'Bild für die Bühne einer Webseite' },
  { _id: 'online', name: 'Online', tooltip: 'Bildmaterial für Webseiten' },
  { _id: 'socialMedia', name: 'Social Media', tooltip: 'Bildmaterial für Social Media' },
  {
    _id: 'inside',
    name: 'Innenseite',
    tooltip: 'Sideshot vom Key Visual bzw. Motiv, das nicht als Key Visual im Einsatz und ohne Corporate Elemente ist',
    tooltipUser: 'Sideshot vom Key Visual',
  },
];

export const ASSET_TYPE = [
  { _id: 'audio', name: 'Audio' },
  { _id: 'picture', name: 'Bild' },
  { _id: 'graphic', name: 'Grafik' },
  { _id: 'seal', name: 'Siegel' },
  { _id: 'miscellaneous', name: 'Sonstiges' },
  { _id: 'video', name: 'Video' },
];

export const FILE_TYPE = [
  { _id: '3D Manufacturing File', name: '3D Manufacturing File' },
  { _id: '3D Studio MAX scene', name: '3D Studio MAX scene' },
  { _id: '3D Studio Scene', name: '3D Studio Scene' },
  { _id: '3D-Web-Packet', name: '3D-Web-Packet' },
  { _id: 'AVI Video', name: 'AVI Video' },
  { _id: 'Additive Manufacturing File', name: 'Additive Manufacturing File' },
  { _id: 'Adobe Digital Negative RAW-Bild', name: 'Adobe Digital Negative RAW-Bild' },
  { _id: 'Adobe ExtendScript', name: 'Adobe ExtendScript' },
  { _id: 'Adobe Flash Animation', name: 'Adobe Flash Animation' },
  { _id: 'Adobe Folio-Dokument', name: 'Adobe Folio-Dokument' },
  { _id: 'Adobe FrameMaker Interchange-Format', name: 'Adobe FrameMaker Interchange-Format' },
  { _id: 'Adobe FrameMaker-Buch', name: 'Adobe FrameMaker-Buch' },
  { _id: 'Adobe FrameMaker-Dokument', name: 'Adobe FrameMaker-Dokument' },
  { _id: 'Adobe Illustrator-Dokument', name: 'Adobe Illustrator-Dokument' },
  { _id: 'Adobe InCopy Interchange-Dokument', name: 'Adobe InCopy Interchange-Dokument' },
  { _id: 'Adobe InCopy Markup Language (ICML)', name: 'Adobe InCopy Markup Language (ICML)' },
  { _id: 'Adobe InDesign InCopy', name: 'Adobe InDesign InCopy' },
  { _id: 'Adobe InDesign Interchange-Dokument', name: 'Adobe InDesign Interchange-Dokument' },
  { _id: 'Adobe InDesign Markup Language (IDML)', name: 'Adobe InDesign Markup Language (IDML)' },
  { _id: 'Adobe InDesign Snippet-Dokument', name: 'Adobe InDesign Snippet-Dokument' },
  { _id: 'Adobe InDesign Snippet-Dokument (IDMS)', name: 'Adobe InDesign Snippet-Dokument (IDMS)' },
  { _id: 'Adobe InDesign-Bibliothek', name: 'Adobe InDesign-Bibliothek' },
  { _id: 'Adobe InDesign-Dokument', name: 'Adobe InDesign-Dokument' },
  { _id: 'Adobe Photoshop-Bild', name: 'Adobe Photoshop-Bild' },
  { _id: 'Adobe Photoshop-Bild Groß', name: 'Adobe Photoshop-Bild Groß' },
  { _id: 'Adobe Premiere Pro Projekt', name: 'Adobe Premiere Pro Projekt' },
  { _id: 'Advanced Recording Format', name: 'Advanced Recording Format' },
  { _id: 'Apple Disk Image', name: 'Apple Disk Image' },
  { _id: 'Apple Final Cut Pro Event', name: 'Apple Final Cut Pro Event' },
  { _id: 'Apple Final Cut Pro Projekt', name: 'Apple Final Cut Pro Projekt' },
  { _id: 'Apple Final Cut Pro XML', name: 'Apple Final Cut Pro XML' },
  { _id: 'Apple Keynote', name: 'Apple Keynote' },
  { _id: 'Apple Numbers', name: 'Apple Numbers' },
  { _id: 'Apple Pages', name: 'Apple Pages' },
  { _id: 'AppleScript (Skript)', name: 'AppleScript (Skript)' },
  { _id: 'AppleScript (Text)', name: 'AppleScript (Text)' },
  { _id: 'Artifacts Composer-Projekt', name: 'Artifacts Composer-Projekt' },
  { _id: 'Audio Interchange File Format', name: 'Audio Interchange File Format' },
  { _id: 'AutoCAD-Zeichnung', name: 'AutoCAD-Zeichnung' },
  { _id: 'Autodesk FBX Interchange-Datei', name: 'Autodesk FBX Interchange-Datei' },
  { _id: 'Away3D-Dokument', name: 'Away3D-Dokument' },
  { _id: 'BMP-Bild', name: 'BMP-Bild' },
  { _id: 'Babylon File', name: 'Babylon File' },
  { _id: 'Balsamiq Mockups-Dokument', name: 'Balsamiq Mockups-Dokument' },
  { _id: 'Blender 3D Data-Datei', name: 'Blender 3D Data-Datei' },
  { _id: 'Bohemian Code Sketch-Dokument', name: 'Bohemian Code Sketch-Dokument' },
  { _id: 'CAD-Zeichnung', name: 'CAD-Zeichnung' },
  { _id: 'COLLADA Exchange-Datei', name: 'COLLADA Exchange-Datei' },
  { _id: 'CSS', name: 'CSS' },
  { _id: 'CSV', name: 'CSV' },
  { _id: 'Canon 2 RAW-Bild', name: 'Canon 2 RAW-Bild' },
  { _id: 'Canon CIFF RAW-Bild', name: 'Canon CIFF RAW-Bild' },
  { _id: 'Cinema 4D Model-Datei', name: 'Cinema 4D Model-Datei' },
  { _id: 'Design Web Format', name: 'Design Web Format' },
  { _id: 'Digital-Video-Datei', name: 'Digital-Video-Datei' },
  { _id: 'DivX Video', name: 'DivX Video' },
  { _id: 'Drawing Interchange Format', name: 'Drawing Interchange Format' },
  { _id: 'E-mail Nachricht', name: 'E-mail Nachricht' },
  { _id: 'EPS-Dokument', name: 'EPS-Dokument' },
  { _id: 'EPUB', name: 'EPUB' },
  { _id: 'Embedded OpenType Font', name: 'Embedded OpenType Font' },
  { _id: 'Epson RAW-Bild', name: 'Epson RAW-Bild' },
  { _id: 'Flash Video', name: 'Flash Video' },
  { _id: 'FreeMarker template', name: 'FreeMarker template' },
  { _id: 'Fuji RAW Image', name: 'Fuji RAW Image' },
  { _id: 'GIF-Bild', name: 'GIF-Bild' },
  { _id: 'GL Transmission Format (Binary)', name: 'GL Transmission Format (Binary)' },
  { _id: 'Groovy-Skript', name: 'Groovy-Skript' },
  { _id: 'HTML', name: 'HTML' },
  { _id: 'HTML Component File ', name: 'HTML Component File ' },
  { _id: 'Hasselblad 3F RAW-Bild', name: 'Hasselblad 3F RAW-Bild' },
  { _id: 'High Dynmaic Range Image', name: 'High Dynmaic Range Image' },
  { _id: 'High efficiency image file', name: 'High efficiency image file' },
  { _id: 'JPEG-Bild', name: 'JPEG-Bild' },
  { _id: 'JSON', name: 'JSON' },
  { _id: 'Java', name: 'Java' },
  { _id: 'Java Webstart', name: 'Java Webstart' },
  { _id: 'Java-Archiv', name: 'Java-Archiv' },
  { _id: 'JavaScript ', name: 'JavaScript ' },
  { _id: 'Kodak DC RAW-Bild', name: 'Kodak DC RAW-Bild' },
  { _id: 'Kodak DC25 RAW-Bild', name: 'Kodak DC25 RAW-Bild' },
  { _id: 'Kodak RAW-Bild', name: 'Kodak RAW-Bild' },
  { _id: 'LESS', name: 'LESS' },
  { _id: 'MP3', name: 'MP3' },
  { _id: 'MPEG Transportstrom', name: 'MPEG Transportstrom' },
  { _id: 'MPEG Video', name: 'MPEG Video' },
  { _id: 'MPEG-4 Audio', name: 'MPEG-4 Audio' },
  { _id: 'MPEG-4 Video', name: 'MPEG-4 Video' },
  { _id: 'MS-Excel Dokument mit Makros, OOXML', name: 'MS-Excel Dokument mit Makros, OOXML' },
  { _id: 'MS-Excel Vorlage mit Makros, OOXML', name: 'MS-Excel Vorlage mit Makros, OOXML' },
  { _id: 'MS-Excel-Dokument', name: 'MS-Excel-Dokument' },
  { _id: 'MS-Excel-Dokument OOXML', name: 'MS-Excel-Dokument OOXML' },
  { _id: 'MS-PowerPoint Dokument mit Makros, OOXML', name: 'MS-PowerPoint Dokument mit Makros, OOXML' },
  { _id: 'MS-PowerPoint Vorlage mit Makros, OOXML', name: 'MS-PowerPoint Vorlage mit Makros, OOXML' },
  { _id: 'MS-PowerPoint-Dokument', name: 'MS-PowerPoint-Dokument' },
  { _id: 'MS-PowerPoint-Dokument OOXML', name: 'MS-PowerPoint-Dokument OOXML' },
  { _id: 'MS-PowerPoint-Slideshow OOXML', name: 'MS-PowerPoint-Slideshow OOXML' },
  { _id: 'MS-PowerPoint-Vorlage OOXML', name: 'MS-PowerPoint-Vorlage OOXML' },
  { _id: 'MS-Visio Vorlage', name: 'MS-Visio Vorlage' },
  { _id: 'MS-Visio Web Zeichnung', name: 'MS-Visio Web Zeichnung' },
  { _id: 'MS-Visio-Diagramm', name: 'MS-Visio-Diagramm' },
  { _id: 'MS-Visio-Schablone', name: 'MS-Visio-Schablone' },
  { _id: 'MS-Visio-XML-Diagramm', name: 'MS-Visio-XML-Diagramm' },
  { _id: 'MS-Visio-XML-Schablone', name: 'MS-Visio-XML-Schablone' },
  { _id: 'MS-Visio-XML-Vorlage', name: 'MS-Visio-XML-Vorlage' },
  { _id: 'MS-Visio-Zusatzmodul', name: 'MS-Visio-Zusatzmodul' },
  { _id: 'MS-Word Dokument mit Makros, OOXML', name: 'MS-Word Dokument mit Makros, OOXML' },
  { _id: 'MS-Word Vorlage OOXML', name: 'MS-Word Vorlage OOXML' },
  { _id: 'MS-Word Vorlage mit Makros, OOXML', name: 'MS-Word Vorlage mit Makros, OOXML' },
  { _id: 'MS-Word-Dokument', name: 'MS-Word-Dokument' },
  { _id: 'MS-Word-Dokument OOXML', name: 'MS-Word-Dokument OOXML' },
  { _id: 'Markdown', name: 'Markdown' },
  { _id: 'Material eXchange Format', name: 'Material eXchange Format' },
  { _id: 'MathML', name: 'MathML' },
  { _id: 'Matroska Video', name: 'Matroska Video' },
  { _id: 'Maya Ascii Scene', name: 'Maya Ascii Scene' },
  { _id: 'Maya Binary Scene', name: 'Maya Binary Scene' },
  { _id: 'Minolta RAW-Bild', name: 'Minolta RAW-Bild' },
  { _id: 'Nikon RAW-Bild', name: 'Nikon RAW-Bild' },
  { _id: 'OS-X-Programm', name: 'OS-X-Programm' },
  { _id: 'Ogg compressed music', name: 'Ogg compressed music' },
  { _id: 'Ogg compressed video', name: 'Ogg compressed video' },
  { _id: 'Ogg multimedia', name: 'Ogg multimedia' },
  { _id: 'Olympus RAW-Bild', name: 'Olympus RAW-Bild' },
  { _id: 'OmniGraffle-Dokument', name: 'OmniGraffle-Dokument' },
  { _id: 'OpenDocument Präsentation', name: 'OpenDocument Präsentation' },
  { _id: 'OpenDocument Präsentation Vorlage', name: 'OpenDocument Präsentation Vorlage' },
  { _id: 'OpenDocument Tabelle', name: 'OpenDocument Tabelle' },
  { _id: 'OpenDocument Tabelle Vorlage', name: 'OpenDocument Tabelle Vorlage' },
  { _id: 'OpenDocument Text', name: 'OpenDocument Text' },
  { _id: 'OpenDocument Text Vorlage', name: 'OpenDocument Text Vorlage' },
  { _id: 'OpenDocument Zeichnung', name: 'OpenDocument Zeichnung' },
  { _id: 'OpenDocument Zeichnung Vorlage', name: 'OpenDocument Zeichnung Vorlage' },
  { _id: 'OpenOffice-Extension', name: 'OpenOffice-Extension' },
  { _id: 'OpenOffice.org 1.0 Präsentation', name: 'OpenOffice.org 1.0 Präsentation' },
  { _id: 'OpenOffice.org 1.0 Präsentation Vorlage', name: 'OpenOffice.org 1.0 Präsentation Vorlage' },
  { _id: 'OpenOffice.org 1.0 Tabelle', name: 'OpenOffice.org 1.0 Tabelle' },
  { _id: 'OpenOffice.org 1.0 Tabelle Vorlage', name: 'OpenOffice.org 1.0 Tabelle Vorlage' },
  { _id: 'OpenOffice.org 1.0 Text', name: 'OpenOffice.org 1.0 Text' },
  { _id: 'OpenOffice.org 1.0 Text Vorlage', name: 'OpenOffice.org 1.0 Text Vorlage' },
  { _id: 'OpenOffice.org 1.0 Zeichnung', name: 'OpenOffice.org 1.0 Zeichnung' },
  { _id: 'OpenOffice.org 1.0 Zeichnung Vorlage', name: 'OpenOffice.org 1.0 Zeichnung Vorlage' },
  { _id: 'OpenType Font', name: 'OpenType Font' },
  { _id: 'Outlook-Mailnachricht', name: 'Outlook-Mailnachricht' },
  { _id: 'PDF-Dokument', name: 'PDF-Dokument' },
  { _id: 'PHP', name: 'PHP' },
  { _id: 'PICT-Bild', name: 'PICT-Bild' },
  { _id: 'PNG-Bild', name: 'PNG-Bild' },
  { _id: 'Pentax RAW-Bild', name: 'Pentax RAW-Bild' },
  { _id: 'Perl', name: 'Perl' },
  { _id: 'Playlist', name: 'Playlist' },
  { _id: 'Python', name: 'Python' },
  { _id: 'Quark XPress-Dokument', name: 'Quark XPress-Dokument' },
  { _id: 'Quicktime-Film', name: 'Quicktime-Film' },
  { _id: 'RTF-Dokument', name: 'RTF-Dokument' },
  { _id: 'RelaxNG-Schema', name: 'RelaxNG-Schema' },
  { _id: 'Ruby', name: 'Ruby' },
  { _id: 'STEP 3D CAD-Datei', name: 'STEP 3D CAD-Datei' },
  { _id: 'Scalable Vector Graphics', name: 'Scalable Vector Graphics' },
  { _id: 'Shockwave Flash', name: 'Shockwave Flash' },
  { _id: 'Sigma X3F RAW-Bild', name: 'Sigma X3F RAW-Bild' },
  { _id: 'Sony 2 RAW Image', name: 'Sony 2 RAW Image' },
  { _id: 'Sony Alpha RAW-Bild', name: 'Sony Alpha RAW-Bild' },
  { _id: 'Sony RAW-Bild', name: 'Sony RAW-Bild' },
  { _id: 'Stereolithography File', name: 'Stereolithography File' },
  { _id: 'TIFF-Bild', name: 'TIFF-Bild' },
  { _id: 'Text', name: 'Text' },
  { _id: 'TrueType Font Collection', name: 'TrueType Font Collection' },
  { _id: 'TrueType-Font', name: 'TrueType-Font' },
  { _id: 'Unbekannt', name: 'Unbekannt' },
  { _id: 'Unity Package Format', name: 'Unity Package Format' },
  { _id: 'Unity Scene Format', name: 'Unity Scene Format' },
  { _id: 'Unity WebL Player Package', name: 'Unity WebL Player Package' },
  { _id: 'Visual Basic Script', name: 'Visual Basic Script' },
  { _id: 'WMV Video', name: 'WMV Video' },
  { _id: 'Waveform Audio', name: 'Waveform Audio' },
  { _id: 'Wavefront 3D Objekt-Datei', name: 'Wavefront 3D Objekt-Datei' },
  { _id: 'Web Open Font Format', name: 'Web Open Font Format' },
  { _id: 'Web Open Font Format 2', name: 'Web Open Font Format 2' },
  { _id: 'Web Video Text Tracks Format', name: 'Web Video Text Tracks Format' },
  { _id: 'WebM video', name: 'WebM video' },
  { _id: 'WebP image', name: 'WebP image' },
  { _id: 'Windows Enhanced Metafile', name: 'Windows Enhanced Metafile' },
  { _id: 'Windows Metafile', name: 'Windows Metafile' },
  { _id: 'X.509 Zertifikat', name: 'X.509 Zertifikat' },
  { _id: 'XHTML-Text', name: 'XHTML-Text' },
  { _id: 'XML', name: 'XML' },
  { _id: 'XMind', name: 'XMind' },
  { _id: 'XSL-Stylesheet', name: 'XSL-Stylesheet' },
  { _id: 'ZIP-Archiv', name: 'ZIP-Archiv' },
  { _id: 'censhare server pages', name: 'censhare server pages' },
  { _id: 'censhare-Assets', name: 'censhare-Assets' },
  { _id: 'censhare-Modules', name: 'censhare-Modules' },
  { _id: 'gzip-komprimiert', name: 'gzip-komprimiert' },
  { _id: 'mbox Datenbank', name: 'mbox Datenbank' },
];

/**
 * Lufthansa general information forms
 * @returns
 */
export const vkbGeneralInformationFields = (): FormControlModel[] => [
  {
    formTypeId: '1',
    formFieldName: 'name',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Asset name`,
    placeholder: $localize`:placeholder:Asset name`,
    inputType: 'text',
    disable: true,
    validators: {
      required: true,
    },
    infotext: 'Der Dateiname wird beim Hochladen übernommen und muss gemäß den Benamungsrichtlinien angepasst werden.',
    infotextExternalLink: true,
    widthClass: WidthClass.WFull,
    value: '',
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'status',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Status`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: undefined,
    sortDataSource: false,
    infotext: `(1) Bearbeitung = Asset wird bearbeitet und ist noch nicht für die Nutzung freigegeben. Wichtig: Nach Vervollständigung und Prüfung der Verschlagwortung und Angaben, Status manuell auf Freigabe setzen.
(2) Freigabe = Verschlagwortung und Angaben wurden final bearbeitet. Das Asset wird allen Nutzern zur Verfügung gestellt.
(3) Abgelaufen = Asset ist abgelaufen. Es darf nicht mehr verwendet und muss aus bestehenden Einsatzfeldern (z.B. Webseiten, Werbematerialien) entfernt werden.
(4) Archiv = Das Asset wurde archiviert. Die Nutzungsrechte des Assets sind abgelaufen. Es darf nicht mehr verwendet werden.`,
    userInfotext: `(1) Bearbeitung = Asset wird noch bearbeitet und ist noch nicht für die Nutzung freigegeben.
(2) Freigabe = Asset steht allen Nutzern zur Verfügung und darf gemäß den Nutzungsrechten verwendet werden.  
(3) Abgelaufen = Asset ist abgelaufen. Es darf nicht mehr verwendet und muss aus bestehenden Einsatzfeldern (z.B. Webseiten, Werbematerialien) entfernt werden.
(4) Archiv = Das Asset wurde archiviert. Die Nutzungsrechte des Assets sind abgelaufen. Es darf nicht mehr verwendet werden.`,
    options: [
      { _id: Asset.StatusEnum.Uploaded, name: $localize`Uploaded` },
      { _id: Asset.StatusEnum.Approved, name: $localize`Approved` },
      { _id: Asset.StatusEnum.Archived, name: $localize`Archived` },
      { _id: Asset.StatusEnum.AwaitingApproval, name: $localize`Awaiting approval` },
    ],
    visible: true,
  },
  {
    formTypeId: '2',
    formFieldName: 'agency',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Agency`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: undefined,
    dropDownSearch: true,
    options: [],
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'client',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Client`,
    repeatFieldLabel: true,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: undefined,
    dropDownSearch: true,
    options: [],
    visible: true,
  },
  {
    formTypeId: '2',
    formFieldName: 'brand',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`User group`,
    repeatFieldLabel: true,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: undefined,
    dropDownSearch: true,
    options: [],
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'purposeOfUse',
    fieldType: FieldType.Text,
    fieldLabel: 'Verwendungszweck',
    placeholder: 'Verwendungszweck',
    mandatory: true,
    validators: {
      required: true,
    },
    infotext:
      'Angabe, für welche Maßnahme das Asset eingekauft wurde (z.B. KFZ-Kampagne, Social Media). Wenn Sie das Asset für einen anderen Verwendungszweck nutzen wollen, schauen Sie bitte die Nutzungsrechte bei Exklusivität nach.',
    inputType: 'text',
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'pursue',
    fieldType: FieldType.MultiSelectChip,
    fieldLabel: 'Unternehmen',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
    inputType: '',
    mandatory: true,
    sortDataSource: false,
    validators: {
      required: true,
    },
    infotext: 'Alle Unternehmen anklicken, für die das Asset genutzt werden kann.',
    userInfotext: 'Alle Unternehmen, für die das Asset genutzt werden kann.',
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: PURSUE,
  },
  {
    formTypeId: '1',
    formFieldName: 'assetTypeCustom',
    fieldType: FieldType.MultiSelectChip,
    fieldLabel: 'Datei-Art',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
    inputType: '',
    mandatory: true,
    sortDataSource: false,
    validators: {
      required: true,
    },
    infotext: 'Die Dateiart gibt das Format der Datei an, in dem das Asset vorliegt. Mehrfachauswahl möglich.',
    userInfotext: 'Die Dateiart gibt das Format der Datei an, in dem das Asset vorliegt.',
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: ASSET_TYPE,
  },
  {
    formTypeId: '1',
    formFieldName: 'imageArt',
    fieldType: FieldType.MultiSelectChip,
    fieldLabel: 'Bild-Art',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
    inputType: '',
    mandatory: true,
    sortDataSource: false,
    validators: {
      required: true,
    },
    infotext: 'Die Bildart gibt an, welchen Einsatzzweck das Asset aktuell hat. Mehrfachauswahl möglich',
    userInfotext: 'Die Bildart gibt an, welchen Einsatzzweck das Asset aktuell hat.',
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: IMAGE_ART,
  },
  {
    formTypeId: '1',
    formFieldName: 'pressureProfile',
    fieldType: FieldType.Text,
    fieldLabel: 'Farbprofil',
    placeholder: 'Farbprofil',
    inputType: 'text',
    widthClass: WidthClass.W12,
    hideDetailsView: true,
    value: '',
    infotext: `Die Wahl des Farbprofils richtet sich danach, ob das Bild für den Druck (CMYK + "39L") oder für digitale Nutzung (RGB + sRGB) gedacht ist, um überall die bestmögliche Farbdarstellung zu gewährleisten. Bitte geben Sie folgendes an: 
"39L" bei Bildern im CMYK-Farbraum (z.B. Leitmotive, Innenseiten) 
"sRGB" bei Bildern im RGB-Farbraum (z.B. Online, Bühnenbild, Social Media)`,
    userInfotext: `Das Farbprofil gibt an, ob das Bild für den Druck (CMYK + "39L") oder für digitale Nutzung (RGB + sRGB) gedacht ist, um überall die bestmögliche Farbdarstellung zu gewährleisten.`,
    visible: true,
  },
  {
    formTypeId: '11',
    formFieldName: 'plannedDeletionToggle',
    fieldType: FieldType.Checkbox,
    fieldLabel: $localize`Planned for deletion`,
    placeholder: '',
    editOnly: true,
    widthClass: WidthClass.W13,
    value: '',
    visible: true,
  },
  {
    formTypeId: '12',
    formFieldName: 'plannedDeletion',
    fieldType: FieldType.Date,
    fieldLabel: $localize`Deletion date`,
    placeholder: $localize`DD/MM/YYYY`,
    minDate: new Date(),
    widthClass: WidthClass.W13,
    value: '',
    editOnly: true,
    disable: true,
    validators: {
      required: true,
    },
    visible: true,
  },
];

// Removed from the VKB metadata. To be deleted after a while if not needed anymore.
export const vkbTaggingNTaxonomyFields = (): FormControlModel[] => [
  {
    formTypeId: '4',
    formFieldName: 'metaTags',
    fieldType: FieldType.Text,
    fieldLabel: 'Meta-Tags',
    placeholder: 'Meta-Tags',
    fieldGroup: 'tagging',
    infotext: 'Weiterführende/detailliertere Beschreibung der Datei neben der Verschlagwortung.',
    inputType: 'text',
    widthClass: WidthClass.WFull,
    value: '',
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'miscellaneous',
    fieldType: FieldType.Text,
    fieldLabel: 'Sonstiges',
    placeholder: 'Sonstiges',
    fieldGroup: 'tagging',
    inputType: 'text',
    widthClass: WidthClass.WFull,
    value: '',
    infotext: 'eventuelle weitere wichtige Infos zum Bild',
    visible: true,
  },
];

export const vkbUsageRightsFields = (): FormControlModel[] => [
  {
    formTypeId: '1',
    formFieldName: 'mediaUsage',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Mediennutzung',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: true,
    validators: {
      required: true,
    },
    infotext: 'Die Mediennutzung gibt an, in welchen Medien das Asset eingesetzt werden darf.',
    fieldGroup: 'usageRight',
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: MEDIA_USAGE,
  },
  {
    formTypeId: '4',
    formFieldName: 'mediaUsageText',
    fieldType: FieldType.Text,
    fieldLabel: 'Mediennutzung - Ausnahme(n)',
    placeholder: 'Mediennutzung - Ausnahme(n)',
    infotext: 'Angabe, für welche Medien es eine Nutzungseinschränkung gibt.',
    inputType: 'text',
    fieldGroup: 'usageRight',
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },

  {
    formTypeId: '1',
    formFieldName: 'exclusivity',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Exklusivität',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: true,
    validators: {
      required: true,
    },
    fieldGroup: 'usageRight',
    infotext: `Die Exklusivität gibt an, von wem und wofür das Asset genutzt werden darf.
Wichtig zu wissen:
Im Vertrag mit dem Fotografen/Urheber muss stehen, wer das Asset benutzen darf, wie lange und wofür. Wenn ein Asset nur für bestimmte Einzelunternehmen aus unserem Konzern gekauft wurde, muss das bei den Angaben zu den Nutzungsrechten eingetragen werden.
`,
    userInfotext: `Die Exklusivität gibt an, von wem und wofür das Asset genutzt werden darf.`,
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: EXCLUSIVITY,
  },
  {
    formTypeId: '4',
    formFieldName: 'exclusivityText',
    fieldType: FieldType.Text,
    fieldLabel: 'Exklusivität - Ausnahme(n)',
    placeholder: 'Exklusivität - Ausnahme(n)',
    inputType: 'text',
    infotext: `Detaillierte Angabe der Nutzungseinschränkung. 
Beispiel „Exklusivität - Ausnahme(n)“: Ein exklusives Asset darf nur für bestimmte Produkte, eine Region, einen Konzernbereich (z.B. Personal) oder für die Innenausstattung von Geschäftsräumen verwendet werden.`,
    userInfotext: `Beispiel: Ein exklusives Asset darf nur für bestimmte Produkte, eine Region, einen Konzernbereich (z.B. Personal) oder für die Innenausstattung von Geschäftsräumen verwendet werden. Generelle Nutzungsrechte bleiben davon unberührt, wie z.B. die nicht gestattete Weitergabe von Assets an unsere Kooperationspartner zum Einsatz außerhalb der von uns vermarkteten Produkte.`,
    fieldGroup: 'usageRight',
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'licenseRegion',
    fieldType: FieldType.Text,
    fieldLabel: 'Lizenz-Region',
    placeholder: 'Lizenz-Region',
    inputType: 'text',
    infotext: `Die Lizenzregion gibt an, in welcher Region das Asset eingesetzt werden darf.
Weltweit: Es darf überall eingesetzt werden.
Deutschland: Es darf nur in Deutschland eingesetzt werden.`,
    fieldGroup: 'usageRight',
    mandatory: true,
    validators: {
      required: true,
    },
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'expiryDate',
    fieldType: FieldType.Date,
    fieldLabel: 'Gültigkeit',
    placeholder: $localize`DD/MM/YYYY`,
    minDate: new Date(),
    fieldGroup: 'usageRight',
    mandatory: true,
    validators: {
      required: true,
    },
    infotext: `Die Gültigkeit gibt an, wie lange das Asset genutzt werden darf.
Kein Ablaufdatum: Das Asset darf ohne zeitliche Einschränkung genutzt werden.
Ablaufdatum: Das Asset darf nur bis zum genannten Datum genutzt werden.`,
    widthClass: WidthClass.W14,
    value: '',
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'noExpiry',
    fieldType: FieldType.Checkbox,
    fieldLabel: $localize`No Expiry date`,
    placeholder: '',
    widthClass: WidthClass.W14,
    value: '',
    validators: {
      required: false,
    },
    infotext: `Das Asset darf ohne zeitliche Einschränkung genutzt werden.
Ablaufdatum: Das Asset darf nur bis zum genannten Datum genutzt werden.`,
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'contactPerson',
    fieldType: FieldType.Text,
    fieldLabel: 'Ansprechpartner',
    placeholder: 'Ansprechpartner',
    inputType: 'text',
    mandatory: true,
    validators: {
      required: true,
    },
    infotext: 'Auftraggeber des Assets mit Abteilungskürzel (Bsp. Max Müller - 2KMXY)',
    userInfotext: 'Auftraggeber des Assets mit Abteilungskürzel.',
    fieldGroup: 'usageRight',
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'contactEmail',
    fieldType: FieldType.Text,
    fieldLabel: 'Ansprechpartner Kontaktmail',
    placeholder: 'Ansprechpartner Kontaktmail',
    inputType: 'text',
    mandatory: true,
    validators: {
      required: true,
      email: true,
    },
    infotext: 'Wer benötigt die Info am dringendsten bei Ablauf der Assetrechte? Wenn möglich eine Sammel-E-Mail-Adresse eintragen.',
    fieldGroup: 'usageRight',
    hideDetailsView: true,
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
  {
    formTypeId: '4',
    formFieldName: 'photographer',
    fieldType: FieldType.Text,
    fieldLabel: 'Fotograf/Urheber',
    placeholder: 'Fotograf/Urheber',
    inputType: 'text',
    mandatory: true,
    validators: {
      required: true,
    },
    fieldGroup: 'usageRight',
    widthClass: WidthClass.W12,
    value: '',
    infotext:
      'Angabe des Fotografen/Urhebers. Bei Konzern-Fotoshootings reicht der Name, bei eingekauften Assets der Name des Fotografen, Name der Kollektion und der Bildagentur. Bsp: Max Mustermann/ Kollektion/ Getty Images.',
    userInfotext: 'Name des Fotografen/Urhebers, der Kollektion (bei eingekauften Assets) und der Bildagentur des Assets.',
    visible: true,
  },
];
